import React from 'react';
import { IDatePickerProps } from './types';
import TimeUnitPicker from '../TimeUnitPicker';

const DatePickerStartOf = ({
  datePicker,
  onChange,
}: IDatePickerProps<'DatePickerStartOf'>) => {
  return (
    <TimeUnitPicker
      label={'Start Of'}
      value={1}
      timeUnit={datePicker.unit}
      onChange={(newValue) => {
        onChange({
          __typename: 'DatePickerStartOf',
          unit: newValue,
        });
      }}
    />
  );
};

export default DatePickerStartOf;
